export function parseFoodWeights(json) {
  const raw = JSON.parse(json ?? '[]');
  return raw
    .filter(
      ({ estimated_weight }) =>
        estimated_weight !== null && estimated_weight !== undefined
    )
    .map(({ food_type, estimated_weight }) => ({
      food_type: food_type.toLowerCase(),
      estimated_weight: {
        value: estimated_weight,
        unit: 'lbs',
      },
    }));
}
